// Types
import { RootState } from 'types/RootState.types';

export function showVoucherUnderspendWarning(state: RootState) {
  return (
    !!state.orderForm.voucherUnderspend &&
    !state.payment.giftOptionsModalOpen &&
    !state.orderForm.voucherUnderspendModalClose
  );
}
